import { FlexRow } from "@similarweb/ui-components";
import { SegmentTypeBadge } from "pro-features/pages/segments/StyledComponents";
import {
    ContentContainer,
    LegendTitle,
    Bullet,
    LabelOverflowHidden,
    SegmentNameLabel,
} from "pro-features/pages/segments/components/benchmarkOvertime/StyledComponents";
import { SegmentLegendSubTitle, SegmentLegendTitle, SegmentNamesContainer } from "./styles";

type legendItemsType = {
    color: string;
    displayName: string;
    name: string;
    isWebsite?: boolean;
    domain?: string;
    segmentName?: string;
    isPOP?: boolean;
};

export type LegendPropsTypes = {
    legendItems: legendItemsType[];
    colors: string[];
};

export const LegendItems = ({ legendItems, colors }: LegendPropsTypes) => (
    <FlexRow>
        {legendItems[0]?.isPOP ? (
            <SegmentNamesContainer>
                <SegmentLegendTitle>{legendItems[0]?.domain}</SegmentLegendTitle>
                <SegmentLegendSubTitle>{legendItems[0]?.segmentName}</SegmentLegendSubTitle>
            </SegmentNamesContainer>
        ) : null}

        {legendItems.map(({ color, displayName, domain, name, isWebsite, segmentName }, index) => (
            <ContentContainer key={index}>
                <LegendTitle>
                    <Bullet color={color || colors[index]} />
                    <LabelOverflowHidden>{displayName || domain}</LabelOverflowHidden>
                </LegendTitle>
                {isWebsite ? (
                    <SegmentNameLabel>
                        <SegmentTypeBadge>WEBSITE</SegmentTypeBadge>
                    </SegmentNameLabel>
                ) : (
                    <SegmentNameLabel>{name || segmentName}</SegmentNameLabel>
                )}
            </ContentContainer>
        ))}
    </FlexRow>
);
